import { render, staticRenderFns } from "./DynamicField.vue?vue&type=template&id=58c8ded6&scoped=true&"
import script from "./DynamicField.vue?vue&type=script&lang=js&"
export * from "./DynamicField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicField.vue?vue&type=style&index=0&id=58c8ded6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8ded6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VSelect,VTextField,VTextarea})
